var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: _vm.modalId,
      "loaders-disabled": "",
      "modal-dialog-size": "xl",
    },
    on: {
      show: _vm.handleShow,
      shown: function ($event) {
        return _vm.handleShown(_vm.currentItemType)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("direct-to-lender.lenderSubmit.createActivityFrom")
                ) +
                "\n    " +
                _vm._s(_vm.startCase(_vm.currentItemType)) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "generate--old-item card" },
              [
                _c(
                  _vm.getTimelineComponent(_vm.currentItemType),
                  _vm._b(
                    {
                      ref: "referrerTimelineComponent",
                      tag: "component",
                      attrs: { id: _vm.currentItemId },
                    },
                    "component",
                    Object.assign(
                      {},
                      { referrerId: _vm.referrerId },
                      _vm.timelineItem,
                      { disabledActions: true }
                    ),
                    false
                  )
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "generate--separator my-1 text-center text-primary",
              },
              [
                _c("icon", {
                  attrs: { name: "angle-double-down", "aria-hidden": "true" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "generate--new-item card" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("referrer-follow-up-tab", {
                    ref: "referrerFollowUpTab",
                    attrs: {
                      "form-id": "generate-from-note",
                      "referrer-id": _vm.referrerId,
                      "current-tab": "follow-up",
                      "tab-data": _vm.getTabData(_vm.currentItemType),
                    },
                    on: { add: _vm.handleItemAdd },
                  }),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }